import type { ContentNode, DocumentState } from '../document-types';
import type { PositionedNodeHandler, RenderContext } from './types';

export class DisclaimerHandler implements PositionedNodeHandler {
  readonly type = 'disclaimer';
  readonly position = 'bottom' as const;

  render(
    _node: ContentNode | DocumentState,
    _parent: ContentNode | DocumentState | null,
    childContent: string,
    _ctx: RenderContext
  ): string {
    return '> **Disclaimer:** ' + childContent.trim() + '\n\n';
  }
}
